/* global propel */
import { __ } from '@wordpress/i18n';
import throttle from 'lodash-es/throttle.js';
import sanitizeHTML from 'propel/sanitizeHTML';

const propelInit = function() {
const liveSearchElements = document.querySelectorAll('.live-search');

const initializeLiveSearchForm = (liveSearchElement) => {
	const form = liveSearchElement.querySelector('.live-search__form');
	const input = liveSearchElement.querySelector('.live-search__input');
	const results = liveSearchElement.querySelector('.live-search__results');
	const closeButton = liveSearchElement.querySelector('.live-search__close');

	if (!form || !input || !results || !closeButton) {
		return;
	}

	const searchUrl = `${window.propel.siteUrl}/wp-json/wp/v2/search?per_page=5`;

	const fetchResults = async (query) => {
		input.setAttribute('aria-expanded', 'true');
		results.classList.add('live-search__results--loading');

		try {
			const response = await fetch(`${searchUrl}&search=${query}`);
			const data = await response.json();
			const totalResults = response.headers.get('X-WP-Total');

			results.innerHTML = '';

			if (0 === data.length) {
				const noResultsMessage = document.createElement('div');
				noResultsMessage.classList.add('live-search__no-results');
				noResultsMessage.textContent = __('No results found', 'propel');
				results.appendChild(noResultsMessage);
			} else {
				data.forEach((item) => {
					if (!item.url || !item.title) {
						return;
					}

					const resultLink = document.createElement('a');
					resultLink.classList.add('live-search__result-link');
					resultLink.setAttribute('role', 'option');
					resultLink.href = item.url;

					const resultLinkText = document.createElement('span');
					resultLinkText.innerHTML = sanitizeHTML(item.title);
					resultLink.appendChild(resultLinkText);
					results.appendChild(resultLink);
				});

				if (totalResults > 5) {
					const viewMoreLink = document.createElement('a');
					viewMoreLink.href = `${window.propel.siteUrl}/?s=${query}`;
					viewMoreLink.classList.add('live-search__view-more-link');

					// translators: %s is the number of additional results
					viewMoreLink.textContent = __(
						'View all %s results',
						'propel'
					).replace('%s', totalResults);

					results.appendChild(viewMoreLink);
				}
			}

			liveSearchElement.classList.add('live-search--active');
			results.classList.add('live-search__results--active');
			addCloseListeners();
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error(
				__('Error fetching search results:', 'propel'),
				error
			);

			const errorMessage = document.createElement('p');

			errorMessage.textContent = __(
				'Error fetching search results. Please try again later.',
				'propel'
			);

			results.appendChild(errorMessage);
			liveSearchElement.classList.add('live-search--active');
			results.classList.add('live-search__results--active');
			addCloseListeners();
		} finally {
			results.classList.remove('live-search__results--loading');
		}
	};

	const closeResults = () => {
		results.innerHTML = '';
		liveSearchElement.classList.remove('live-search--active');
		results.classList.remove('live-search__results--active');
		input.setAttribute('aria-expanded', 'false');
		removeCloseListeners();
	};

	const handleClickOutside = (event) => {
		if (!liveSearchElement.contains(event.target)) {
			closeResults();
		}
	};

	const handleEscKey = (event) => {
		if (event.key === 'Escape') {
			closeResults();
		}
	};

	const addCloseListeners = () => {
		document.addEventListener('click', handleClickOutside);
		document.addEventListener('keydown', handleEscKey);
	};

	const removeCloseListeners = () => {
		document.removeEventListener('click', handleClickOutside);
		document.removeEventListener('keydown', handleEscKey);
	};

	input.addEventListener(
		'input',
		throttle(() => {
			if (input.value.length > 2) {
				fetchResults(input.value);
			} else {
				closeResults();
			}
		}, 1000)
	);

	closeButton.addEventListener('click', closeResults);
};

if (liveSearchElements.length > 0 && propel.siteUrl) {
	liveSearchElements.forEach((liveSearchElement) => {
		initializeLiveSearchForm(liveSearchElement);
	});
}

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['live-search'] = window.propel.blocks['live-search'] || {};
window.propel.blocks['live-search'].script = propelInit;
